import { Libraries } from "@react-google-maps/api";

const GOOGLE_LIBS: Libraries = ['places'];

const env = window.ENV ?? ({} as Window['ENV']);

export const configuration = {
  API_BASE_URL: env.API_BASE_URL,
  API_URL: env.API_URL,
  GOOGLE_API_KEY: env.GOOGLE_API_KEY,
  TINYMCE_API_KEY: env.TINYMCE_API_KEY,
  GOOGLE_LIBS,
};
